import globalStore from '$$globalStore';
import constants from '../../../helpers/constants';

export default (taskId, ganttId, resourcesList) => {
  const currentTaskResources = globalStore.getters['tasksModel/getResourcesForTask'](+ganttId, +taskId);
  const changedTaskResources = [];

  resourcesList.forEach(newResource => {
    const currentResource = currentTaskResources.find(r => r.resource_id === newResource.resource_id);
    const actionItem = {
      resource_id: newResource.resource_id,
    };

    if (newResource.selected && !currentResource) {
      changedTaskResources.push({ ...actionItem, value: newResource.value, action: 'insert' });
    }

    if (!newResource.selected && currentResource) {
      if (newResource.type === constants.RESOURCE_TIME_TYPE && currentResource.resource_tasks_id) {
        actionItem.customEstimation = [{
          resource_task_id: currentResource.resource_tasks_id,
          action: 'delete',
        }];
      }

      changedTaskResources.push({ ...actionItem, action: 'delete' });
    }

    if (newResource.selected && currentResource && newResource.value !== currentResource.value) {
      if (newResource.type === constants.RESOURCE_TIME_TYPE && currentResource.resource_tasks_id) {
        actionItem.customEstimation = [{
          resource_task_id: currentResource.resource_tasks_id,
          action: 'delete',
        }];
      }

      changedTaskResources.push({ ...actionItem, value: newResource.value, action: 'update' });
    }
  });

  return changedTaskResources;
};
